import backendService from './backend';

export { extractRowAdsBannerIds, extractHomeBannerIds } from './layoutPageElementIds';

/**
 * @param {string} pageId
 * @returns {Promise<object|null>}
 */
export async function fetchLayoutPageById(pageId) {
  try {
    const id = String(pageId || '').trim();
    if (!id) {
      return null;
    }
    const { data } = await backendService.layout.v5.getPage(id);
    return data ?? null;
  } catch (error) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error('[layoutPages]', error);
    }
    return null;
  }
}

/**
 * @returns {Promise<object|null>}
 */
export async function fetchLayoutPageLive() {
  return fetchLayoutPageById('live');
}

/**
 * @returns {Promise<object|null>}
 */
export async function fetchLayoutPageDeportes() {
  return fetchLayoutPageById('deportes');
}
